export default __webpack_public_path__ + "static/media/1.30e62a4d.jpg";